import { required, maxLength, range, nested,table, property, alpha, alphaNumeric, numeric, uppercase,pattern,minDate,maxNumber,maxDate,lowercase,hexColor,email,contains,compare } from '@rx/annotations';
@table('vApplicationIssues')
export class vApplicationIssue {
    constructor(vApplicationIssue?: vApplicationIssue )  {
        let properties = [ "applicationIssueId", "applicationName", "createdById", "createdDateTime", "description", "developerNote", "pageName", "priority", "status", "title", "type",];
        for (let property of properties)
            if (vApplicationIssue && (vApplicationIssue[property] || vApplicationIssue[property] == 0))
                this[property] = vApplicationIssue[property];
    }
 
    @range(1,2147483647)
	@property('ApplicationIssueId')
	applicationIssueId : number =   undefined;
 
    @required()
    @maxLength(100)
	@property('ApplicationName')
	applicationName : string = undefined ;
 
    @range(1,2147483647)
	@property('CreatedById')
	createdById : number =   undefined;
 
    @required()
	@property('CreatedDateTime')
	createdDateTime : Date =   undefined;
 
    @maxLength(500)
	@property('Description')
	description : string = undefined ;
 
    @maxLength(500)
	@property('DeveloperNote')
	developerNote : string = undefined ;
 
    @maxLength(50)
	@property('PageName')
	pageName : string = undefined ;
 
    @maxLength(100)
	@property('Priority')
	priority : string = undefined ;
 
    @maxLength(100)
	@property('Status')
	status : string = undefined ;
 
    @maxLength(50)
	@property('Title')
	title : string = undefined ;
 
    @maxLength(100)
	@property('Type')
	type : string = undefined ;



}
